export const BankProgressSteps = [
  'phoneVerification',
  'bankIdentification',
  'signDocuments',
];

export const videoProgressSteps = ['videoIdentification'];
